// DDCFB New File
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { ContentMyDelta } from '../../model/content/contentmydelta.model';
import { CommonService } from '../../services/common.service';
// import { ContentTodayPanel } from '../../model/content/contenttodaypanel.model';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

@Component({
  selector: 'ngc-flyout-loggedin-user',
  templateUrl: './flyout-loggedin-user.component.html'
})
export class FlyoutLoggedinUserComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  flyOutPositionHeight: any;
  // public feedCounterValue: any;
  public flyoutContent: ContentMyDelta;
  profilePickerModalLoaded = false;
  // public flyoutTodayContent: ContentTodayPanel;
  public timeouts = [];
  isModalShown = false;
  aemErrorMessages: any;
  modalConfig = {
    animated: false,
    show: true
  };

  loggedInUserFlyoutObj: any;
  errorMessagesServiceSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  corpInfoDetails: any;
  showNewProfileSelector = false;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private _el: ElementRef,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    public bsModalRef: BsModalRef,
    private _renderer: Renderer2,
    private errorService: ErrorMessagesReducerStoreService,
    private cookieHelper: CookieHelper,
    private srv: CommonService,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // this.feedCounterValue = parseInt(this.cookieHelper.getCookies('newFeedAdvisoriesCountNumber'));
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.loggedInUserFlyoutObj = this.srv.flyoutPosition(
      'logged-in user',
      false
    );
    this.flyOutPositionHeight =
      this.loggedInUserFlyoutObj !== undefined &&
      this.loggedInUserFlyoutObj !== null
        ? this.loggedInUserFlyoutObj.flyOutPositionHeight
        : 0;
    if (isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 992 && document.body.scrollWidth > 767) {
        const modelContainer = document.getElementsByTagName('modal-container');
        if (modelContainer && modelContainer.length > 0) {
          modelContainer[0].classList.add('notification-loggedin-modal');
          this.profilePickerModalLoaded = true;
        }
      }
    }
  }

  /* updateFeedCount() {
    this.feedCounterValue = 0;
    this.cookieHelper.setCookies('newFeedAdvisoriesCountNumber', this.feedCounterValue);
    let setNewDate: Date = new Date();
    let visitedTodayDate: string = setNewDate.getFullYear().toString() + '-' + setNewDate.getMonth().toString() + '-' + setNewDate.getDate().toString();
    this.cookieHelper.setCookies('lastVisitedFeedAdvisories', visitedTodayDate);
    let el = document.getElementsByClassName('feed-counter')[0];
    this._renderer.setStyle(el, 'display', 'none');
  }*/

  ngOnInit() {
    const el = document.getElementsByClassName('toggle-flyout1')[0];
    if (el !== null && el !== undefined) {
      el.className += ' toggle-up';
    }
    this.loggedInUserFlyoutObj = this.srv.flyoutPosition(
      'logged-in user',
      false
    );
    this.flyOutPositionHeight =
      this.loggedInUserFlyoutObj !== undefined &&
      this.loggedInUserFlyoutObj !== null
        ? this.loggedInUserFlyoutObj.flyOutPositionHeight
        : 0;
    this.errorMessagesServiceSubscribe = this.errorService.errorMessages
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data) {
          if (data.errorMessages) {
            this.aemErrorMessages = data.errorMessages;
          }
        }
      });
    this.contentHeaderFooterServiceSubscribe =
      this.contentService.contentHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.showNewProfileSelector =
                !!data.header.enableNewProfileSelector;
              this.flyoutContent = data.header.auxiliaryNavigation.get(
                'myFlightPanel'
              )
                ? data.header.auxiliaryNavigation.get('myFlightPanel').details
                : null;
              // this.flyoutTodayContent = (data.header.auxiliaryNavigation.get('todayPanel')) ? data.header.auxiliaryNavigation.get('todayPanel').details : null;
              this.changeDetection.detectChanges();
            }
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
  }

  ngAfterViewInit() {
    this.focusActiveTab();
    const modalElement = document.getElementsByTagName('modal-container');
    if (modalElement && modalElement.length > 0) {
      modalElement[0].addEventListener(
        'click',
        this.backDropClickHandler.bind(this)
      );
    }
    this.setFocus(
      document.body.querySelector('modal-container .content-loggedIn')
    );
  }

  setFocus(element) {
    const focusableEls = element.querySelectorAll(
      'a[href], [tabindex], input, button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    );
    const firstFocusableEl = focusableEls[1];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];
    const KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        /* shift + tab */
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

  backDropClickHandler(event) {
    const flyout = event.target.parentElement;
    if (flyout) {
      const isModalContainerClicked =
        event.target.classList.contains('notification-loggedin-modal') ||
        flyout.classList.contains('modal-content');
      if (this.profilePickerModalLoaded && isModalContainerClicked) {
        const el = this._el.nativeElement.querySelector('.toggle-up');
        if (el !== null && el !== undefined) {
          el.className = 'toggle-flyout';
          el.querySelector('img').setAttribute('alt', 'Collapsed');
        }
        this.bsModalRef.hide();
        this.profilePickerModalLoaded = false;
      }
    }
  }

  setCorpInfo(corpData) {
    this.corpInfoDetails = corpData;
  }

  focusActiveTab() {
    this._el.nativeElement.querySelector('.loggedin-user-modal').focus();
  }

  setModalHeight() {
    if (
      this._el.nativeElement.querySelector('.loggedin-flyout').offsetParent !==
        undefined &&
      this._el.nativeElement.querySelector('.loggedin-flyout').offsetParent !==
        null
    ) {
      const parentContainer =
        this._el.nativeElement.querySelector('.loggedin-flyout').offsetParent
          .children[0];
      parentContainer.className += 'loggedIn-modal-height';
    }
  }

  close() {
    const el = this._el.nativeElement.querySelector('.toggle-up');
    if (el !== null && el !== undefined) {
      el.className = 'toggle-flyout1';
    }
    this.bsModalRef.hide();
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    if (this.errorMessagesServiceSubscribe) {
      this.errorMessagesServiceSubscribe.unsubscribe();
    } else if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.stopTimeout();
  }
}
